/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthLayoutRouteImport } from './routes/_auth-layout'
import { Route as AuthenticatedSidebarLayoutRouteImport } from './routes/_authenticated/_sidebar-layout'
import { Route as AuthenticatedNosidebarLayoutRouteImport } from './routes/_authenticated/_nosidebar-layout'
import { Route as AuthLayoutCm416ujis000008jzbr1q4f86RouteImport } from './routes/_auth-layout/cm416ujis000008jzbr1q4f86'
import { Route as AuthenticatedSidebarLayoutIndexRouteImport } from './routes/_authenticated/_sidebar-layout/index'
import { Route as AuthenticatedSidebarLayoutUsersRouteImport } from './routes/_authenticated/_sidebar-layout/users'
import { Route as AuthenticatedSidebarLayoutImageToVideoRouteImport } from './routes/_authenticated/_sidebar-layout/image-to-video'
import { Route as AuthenticatedSidebarLayoutImageRenderingRouteImport } from './routes/_authenticated/_sidebar-layout/image-rendering'
import { Route as AuthenticatedSidebarLayoutFlatfindersRouteImport } from './routes/_authenticated/_sidebar-layout/flatfinders'
import { Route as AuthenticatedSidebarLayoutContactRouteImport } from './routes/_authenticated/_sidebar-layout/contact'
import { Route as AuthenticatedSidebarLayoutAboutRouteImport } from './routes/_authenticated/_sidebar-layout/about'
import { Route as SharedFolderFolderIdIndexRouteImport } from './routes/shared/folder/$folderId/index'
import { Route as SharedFlatfinderPublicIdIndexRouteImport } from './routes/shared/flatfinder/$publicId/index'
import { Route as AuthenticatedSidebarLayoutProjectsIndexRouteImport } from './routes/_authenticated/_sidebar-layout/projects/index'
import { Route as AuthenticatedSidebarLayoutEstatesIndexRouteImport } from './routes/_authenticated/_sidebar-layout/estates/index'
import { Route as AuthenticatedSidebarLayoutEstatesMeRouteImport } from './routes/_authenticated/_sidebar-layout/estates/me'
import { Route as SharedVirtualTourEstateIdTourIdIndexRouteImport } from './routes/shared/virtualTour/$estateId/$tourId/index'
import { Route as AuthenticatedSidebarLayoutTenantTenantIdIndexRouteImport } from './routes/_authenticated/_sidebar-layout/tenant/$tenantId/index'
import { Route as AuthenticatedSidebarLayoutTenantTenantIdUsersRouteImport } from './routes/_authenticated/_sidebar-layout/tenant/$tenantId/users'
import { Route as AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRouteImport } from './routes/_authenticated/_sidebar-layout/tenant/$tenantId/subtenants'
import { Route as AuthenticatedSidebarLayoutTenantTenantIdEstatesRouteImport } from './routes/_authenticated/_sidebar-layout/tenant/$tenantId/estates'
import { Route as AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRouteImport } from './routes/_authenticated/_sidebar-layout/tenant/$tenantId/entity-access'
import { Route as AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRouteImport } from './routes/_authenticated/_sidebar-layout/tenant/$tenantId/customer-identity'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/index'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/index'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/flatfinder'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/index'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/index'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/videos'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/images'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/floor-plans'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/videos'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/spherical-images'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/images'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/focus-points'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/floor-plans'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins'
import { Route as AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRouteImport } from './routes/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new'
import { Route as AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRouteImport } from './routes/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/index'
import { Route as AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRouteImport } from './routes/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view'
import { Route as AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRouteImport } from './routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/index'
import { Route as AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRouteImport } from './routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/index'

const CompleteProfileLazyRouteImport = createFileRoute('/complete-profile')()
const AuthLayoutTokenErrorLazyRouteImport = createFileRoute(
  '/_auth-layout/token-error',
)()
const AuthLayoutPasswordResetLazyRouteImport = createFileRoute(
  '/_auth-layout/password-reset',
)()
const AuthLayoutLoginLazyRouteImport = createFileRoute('/_auth-layout/login')()
const AuthenticatedSidebarLayoutShadowmapLazyRouteImport = createFileRoute(
  '/_authenticated/_sidebar-layout/shadowmap',
)()
const AuthenticatedSidebarLayoutProfileLazyRouteImport = createFileRoute(
  '/_authenticated/_sidebar-layout/profile',
)()
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/',
  )()
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/',
  )()
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/',
  )()
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/',
  )()
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/folder/$folderId',
  )()
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/folder/$folderId',
  )()

const CompleteProfileLazyRoute = CompleteProfileLazyRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/complete-profile.lazy').then((d) => d.Route),
)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutTokenErrorLazyRoute =
  AuthLayoutTokenErrorLazyRouteImport.update({
    id: '/token-error',
    path: '/token-error',
    getParentRoute: () => AuthLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth-layout/token-error.lazy').then((d) => d.Route),
  )
const AuthLayoutPasswordResetLazyRoute =
  AuthLayoutPasswordResetLazyRouteImport.update({
    id: '/password-reset',
    path: '/password-reset',
    getParentRoute: () => AuthLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth-layout/password-reset.lazy').then((d) => d.Route),
  )
const AuthLayoutLoginLazyRoute = AuthLayoutLoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthLayoutRoute,
} as any).lazy(() =>
  import('./routes/_auth-layout/login.lazy').then((d) => d.Route),
)
const AuthenticatedSidebarLayoutRoute =
  AuthenticatedSidebarLayoutRouteImport.update({
    id: '/_sidebar-layout',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNosidebarLayoutRoute =
  AuthenticatedNosidebarLayoutRouteImport.update({
    id: '/_nosidebar-layout',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthLayoutCm416ujis000008jzbr1q4f86Route =
  AuthLayoutCm416ujis000008jzbr1q4f86RouteImport.update({
    id: '/cm416ujis000008jzbr1q4f86',
    path: '/cm416ujis000008jzbr1q4f86',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutIndexRoute =
  AuthenticatedSidebarLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutShadowmapLazyRoute =
  AuthenticatedSidebarLayoutShadowmapLazyRouteImport.update({
    id: '/shadowmap',
    path: '/shadowmap',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/shadowmap.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProfileLazyRoute =
  AuthenticatedSidebarLayoutProfileLazyRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/profile.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutUsersRoute =
  AuthenticatedSidebarLayoutUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutImageToVideoRoute =
  AuthenticatedSidebarLayoutImageToVideoRouteImport.update({
    id: '/image-to-video',
    path: '/image-to-video',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutImageRenderingRoute =
  AuthenticatedSidebarLayoutImageRenderingRouteImport.update({
    id: '/image-rendering',
    path: '/image-rendering',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutFlatfindersRoute =
  AuthenticatedSidebarLayoutFlatfindersRouteImport.update({
    id: '/flatfinders',
    path: '/flatfinders',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutContactRoute =
  AuthenticatedSidebarLayoutContactRouteImport.update({
    id: '/contact',
    path: '/contact',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutAboutRoute =
  AuthenticatedSidebarLayoutAboutRouteImport.update({
    id: '/about',
    path: '/about',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const SharedFolderFolderIdIndexRoute =
  SharedFolderFolderIdIndexRouteImport.update({
    id: '/shared/folder/$folderId/',
    path: '/shared/folder/$folderId/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/shared/folder/$folderId/index.lazy').then((d) => d.Route),
  )
const SharedFlatfinderPublicIdIndexRoute =
  SharedFlatfinderPublicIdIndexRouteImport.update({
    id: '/shared/flatfinder/$publicId/',
    path: '/shared/flatfinder/$publicId/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/shared/flatfinder/$publicId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsIndexRoute =
  AuthenticatedSidebarLayoutProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutEstatesIndexRoute =
  AuthenticatedSidebarLayoutEstatesIndexRouteImport.update({
    id: '/estates/',
    path: '/estates/',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesMeRoute =
  AuthenticatedSidebarLayoutEstatesMeRouteImport.update({
    id: '/estates/me',
    path: '/estates/me',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/me.lazy').then(
      (d) => d.Route,
    ),
  )
const SharedVirtualTourEstateIdTourIdIndexRoute =
  SharedVirtualTourEstateIdTourIdIndexRouteImport.update({
    id: '/shared/virtualTour/$estateId/$tourId/',
    path: '/shared/virtualTour/$estateId/$tourId/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/shared/virtualTour/$estateId/$tourId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutTenantTenantIdIndexRoute =
  AuthenticatedSidebarLayoutTenantTenantIdIndexRouteImport.update({
    id: '/tenant/$tenantId/',
    path: '/tenant/$tenantId/',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutTenantTenantIdUsersRoute =
  AuthenticatedSidebarLayoutTenantTenantIdUsersRouteImport.update({
    id: '/tenant/$tenantId/users',
    path: '/tenant/$tenantId/users',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute =
  AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRouteImport.update({
    id: '/tenant/$tenantId/subtenants',
    path: '/tenant/$tenantId/subtenants',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute =
  AuthenticatedSidebarLayoutTenantTenantIdEstatesRouteImport.update({
    id: '/tenant/$tenantId/estates',
    path: '/tenant/$tenantId/estates',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute =
  AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRouteImport.update({
    id: '/tenant/$tenantId/entity-access',
    path: '/tenant/$tenantId/entity-access',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute =
  AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRouteImport.update({
    id: '/tenant/$tenantId/customer-identity',
    path: '/tenant/$tenantId/customer-identity',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteImport.update({
    id: '/projects/$projectId/_dashboard-layout',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteImport.update({
    id: '/estates/$estateId/_dashboard-layout',
    path: '/estates/$estateId',
    getParentRoute: () => AuthenticatedSidebarLayoutRoute,
  } as any)
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRouteImport.update(
    {
      id: '/objects',
      path: '/objects',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteImport.update(
    {
      id: '/media',
      path: '/media',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRouteImport.update(
    {
      id: '/flatfinder',
      path: '/flatfinder',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteImport.update(
    {
      id: '/documents',
      path: '/documents',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteImport.update(
    {
      id: '/media',
      path: '/media',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteImport.update(
    {
      id: '/documents',
      path: '/documents',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRouteImport.update(
    {
      id: '/analytics',
      path: '/analytics',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRouteImport.update(
    {
      id: '/videos',
      path: '/videos',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/videos.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRouteImport.update(
    {
      id: '/images',
      path: '/images',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRouteImport.update(
    {
      id: '/floor-plans',
      path: '/floor-plans',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute,
    } as any,
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRouteImport.update(
    {
      id: '/videos',
      path: '/videos',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/videos.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRouteImport.update(
    {
      id: '/spherical-images',
      path: '/spherical-images',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/spherical-images.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRouteImport.update(
    {
      id: '/images',
      path: '/images',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/images.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRouteImport.update(
    {
      id: '/focus-points',
      path: '/focus-points',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/focus-points.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRouteImport.update(
    {
      id: '/floor-plans',
      path: '/floor-plans',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/floor-plans.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRouteImport.update(
    {
      id: '/digital-twins',
      path: '/digital-twins',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute =
  AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRouteImport.update(
    {
      id: '/estates/$estateId/media/virtual-tour/new',
      path: '/estates/$estateId/media/virtual-tour/new',
      getParentRoute: () => AuthenticatedNosidebarLayoutRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRouteImport.update(
    {
      id: '/$archiveId/',
      path: '/$archiveId/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRouteImport.update(
    {
      id: '/$archiveId/',
      path: '/$archiveId/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute =
  AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRouteImport.update(
    {
      id: '/estates/$estateId/media/virtual-tour/$tourId/',
      path: '/estates/$estateId/media/virtual-tour/$tourId/',
      getParentRoute: () => AuthenticatedNosidebarLayoutRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute =
  AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRouteImport.update(
    {
      id: '/estates/$estateId/media/virtual-tour/$tourId/view',
      path: '/estates/$estateId/media/virtual-tour/$tourId/view',
      getParentRoute: () => AuthenticatedNosidebarLayoutRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRouteImport.update(
    {
      id: '/edit/$mediaId/',
      path: '/edit/$mediaId/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRouteImport.update(
    {
      id: '/edit/$mediaId/',
      path: '/edit/$mediaId/',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRouteImport.update(
    {
      id: '/$archiveId/folder/$folderId',
      path: '/$archiveId/folder/$folderId',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/folder/$folderId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRouteImport.update(
    {
      id: '/$archiveId/folder/$folderId',
      path: '/$archiveId/folder/$folderId',
      getParentRoute: () =>
        AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/folder/$folderId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedSidebarLayoutIndexRoute
  '/logout': typeof LogoutRoute
  '/complete-profile': typeof CompleteProfileLazyRoute
  '/cm416ujis000008jzbr1q4f86': typeof AuthLayoutCm416ujis000008jzbr1q4f86Route
  '/login': typeof AuthLayoutLoginLazyRoute
  '/password-reset': typeof AuthLayoutPasswordResetLazyRoute
  '/token-error': typeof AuthLayoutTokenErrorLazyRoute
  '/about': typeof AuthenticatedSidebarLayoutAboutRoute
  '/contact': typeof AuthenticatedSidebarLayoutContactRoute
  '/flatfinders': typeof AuthenticatedSidebarLayoutFlatfindersRoute
  '/image-rendering': typeof AuthenticatedSidebarLayoutImageRenderingRoute
  '/image-to-video': typeof AuthenticatedSidebarLayoutImageToVideoRoute
  '/users': typeof AuthenticatedSidebarLayoutUsersRoute
  '/profile': typeof AuthenticatedSidebarLayoutProfileLazyRoute
  '/shadowmap': typeof AuthenticatedSidebarLayoutShadowmapLazyRoute
  '/estates/me': typeof AuthenticatedSidebarLayoutEstatesMeRoute
  '/estates/': typeof AuthenticatedSidebarLayoutEstatesIndexRoute
  '/projects/': typeof AuthenticatedSidebarLayoutProjectsIndexRoute
  '/shared/flatfinder/$publicId/': typeof SharedFlatfinderPublicIdIndexRoute
  '/shared/folder/$folderId/': typeof SharedFolderFolderIdIndexRoute
  '/estates/$estateId': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteWithChildren
  '/projects/$projectId': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteWithChildren
  '/tenant/$tenantId/customer-identity': typeof AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute
  '/tenant/$tenantId/entity-access': typeof AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute
  '/tenant/$tenantId/estates': typeof AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute
  '/tenant/$tenantId/subtenants': typeof AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute
  '/tenant/$tenantId/users': typeof AuthenticatedSidebarLayoutTenantTenantIdUsersRoute
  '/tenant/$tenantId/': typeof AuthenticatedSidebarLayoutTenantTenantIdIndexRoute
  '/shared/virtualTour/$estateId/$tourId/': typeof SharedVirtualTourEstateIdTourIdIndexRoute
  '/estates/$estateId/analytics': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute
  '/estates/$estateId/documents': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteWithChildren
  '/estates/$estateId/media': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteWithChildren
  '/projects/$projectId/documents': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteWithChildren
  '/projects/$projectId/flatfinder': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute
  '/projects/$projectId/media': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteWithChildren
  '/projects/$projectId/objects': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute
  '/estates/$estateId/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute
  '/projects/$projectId/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute
  '/estates/$estateId/media/virtual-tour/new': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute
  '/estates/$estateId/media/digital-twins': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute
  '/estates/$estateId/media/floor-plans': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute
  '/estates/$estateId/media/focus-points': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute
  '/estates/$estateId/media/images': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute
  '/estates/$estateId/media/spherical-images': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute
  '/estates/$estateId/media/videos': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute
  '/projects/$projectId/media/floor-plans': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute
  '/projects/$projectId/media/images': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute
  '/projects/$projectId/media/videos': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute
  '/estates/$estateId/media/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute
  '/projects/$projectId/media/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute
  '/estates/$estateId/documents/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute
  '/projects/$projectId/documents/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute
  '/estates/$estateId/media/virtual-tour/$tourId/view': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute
  '/estates/$estateId/media/virtual-tour/$tourId/': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute
  '/estates/$estateId/documents/$archiveId/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  '/projects/$projectId/documents/$archiveId/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  '/estates/$estateId/documents/$archiveId/folder/$folderId': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
  '/projects/$projectId/documents/$archiveId/folder/$folderId': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
  '/estates/$estateId/media/edit/$mediaId/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute
  '/projects/$projectId/media/edit/$mediaId/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedSidebarLayoutIndexRoute
  '/logout': typeof LogoutRoute
  '/complete-profile': typeof CompleteProfileLazyRoute
  '/cm416ujis000008jzbr1q4f86': typeof AuthLayoutCm416ujis000008jzbr1q4f86Route
  '/login': typeof AuthLayoutLoginLazyRoute
  '/password-reset': typeof AuthLayoutPasswordResetLazyRoute
  '/token-error': typeof AuthLayoutTokenErrorLazyRoute
  '/about': typeof AuthenticatedSidebarLayoutAboutRoute
  '/contact': typeof AuthenticatedSidebarLayoutContactRoute
  '/flatfinders': typeof AuthenticatedSidebarLayoutFlatfindersRoute
  '/image-rendering': typeof AuthenticatedSidebarLayoutImageRenderingRoute
  '/image-to-video': typeof AuthenticatedSidebarLayoutImageToVideoRoute
  '/users': typeof AuthenticatedSidebarLayoutUsersRoute
  '/profile': typeof AuthenticatedSidebarLayoutProfileLazyRoute
  '/shadowmap': typeof AuthenticatedSidebarLayoutShadowmapLazyRoute
  '/estates/me': typeof AuthenticatedSidebarLayoutEstatesMeRoute
  '/estates': typeof AuthenticatedSidebarLayoutEstatesIndexRoute
  '/projects': typeof AuthenticatedSidebarLayoutProjectsIndexRoute
  '/shared/flatfinder/$publicId': typeof SharedFlatfinderPublicIdIndexRoute
  '/shared/folder/$folderId': typeof SharedFolderFolderIdIndexRoute
  '/tenant/$tenantId/customer-identity': typeof AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute
  '/tenant/$tenantId/entity-access': typeof AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute
  '/tenant/$tenantId/estates': typeof AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute
  '/tenant/$tenantId/subtenants': typeof AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute
  '/tenant/$tenantId/users': typeof AuthenticatedSidebarLayoutTenantTenantIdUsersRoute
  '/tenant/$tenantId': typeof AuthenticatedSidebarLayoutTenantTenantIdIndexRoute
  '/shared/virtualTour/$estateId/$tourId': typeof SharedVirtualTourEstateIdTourIdIndexRoute
  '/estates/$estateId/analytics': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute
  '/projects/$projectId/flatfinder': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute
  '/projects/$projectId/objects': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute
  '/estates/$estateId': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute
  '/projects/$projectId': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute
  '/estates/$estateId/media/virtual-tour/new': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute
  '/estates/$estateId/media/digital-twins': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute
  '/estates/$estateId/media/floor-plans': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute
  '/estates/$estateId/media/focus-points': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute
  '/estates/$estateId/media/images': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute
  '/estates/$estateId/media/spherical-images': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute
  '/estates/$estateId/media/videos': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute
  '/projects/$projectId/media/floor-plans': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute
  '/projects/$projectId/media/images': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute
  '/projects/$projectId/media/videos': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute
  '/estates/$estateId/media': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute
  '/projects/$projectId/media': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute
  '/estates/$estateId/documents': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute
  '/projects/$projectId/documents': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute
  '/estates/$estateId/media/virtual-tour/$tourId/view': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute
  '/estates/$estateId/media/virtual-tour/$tourId': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute
  '/estates/$estateId/documents/$archiveId': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  '/projects/$projectId/documents/$archiveId': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  '/estates/$estateId/documents/$archiveId/folder/$folderId': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
  '/projects/$projectId/documents/$archiveId/folder/$folderId': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
  '/estates/$estateId/media/edit/$mediaId': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute
  '/projects/$projectId/media/edit/$mediaId': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth-layout': typeof AuthLayoutRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/logout': typeof LogoutRoute
  '/complete-profile': typeof CompleteProfileLazyRoute
  '/_auth-layout/cm416ujis000008jzbr1q4f86': typeof AuthLayoutCm416ujis000008jzbr1q4f86Route
  '/_authenticated/_nosidebar-layout': typeof AuthenticatedNosidebarLayoutRouteWithChildren
  '/_authenticated/_sidebar-layout': typeof AuthenticatedSidebarLayoutRouteWithChildren
  '/_auth-layout/login': typeof AuthLayoutLoginLazyRoute
  '/_auth-layout/password-reset': typeof AuthLayoutPasswordResetLazyRoute
  '/_auth-layout/token-error': typeof AuthLayoutTokenErrorLazyRoute
  '/_authenticated/_sidebar-layout/about': typeof AuthenticatedSidebarLayoutAboutRoute
  '/_authenticated/_sidebar-layout/contact': typeof AuthenticatedSidebarLayoutContactRoute
  '/_authenticated/_sidebar-layout/flatfinders': typeof AuthenticatedSidebarLayoutFlatfindersRoute
  '/_authenticated/_sidebar-layout/image-rendering': typeof AuthenticatedSidebarLayoutImageRenderingRoute
  '/_authenticated/_sidebar-layout/image-to-video': typeof AuthenticatedSidebarLayoutImageToVideoRoute
  '/_authenticated/_sidebar-layout/users': typeof AuthenticatedSidebarLayoutUsersRoute
  '/_authenticated/_sidebar-layout/profile': typeof AuthenticatedSidebarLayoutProfileLazyRoute
  '/_authenticated/_sidebar-layout/shadowmap': typeof AuthenticatedSidebarLayoutShadowmapLazyRoute
  '/_authenticated/_sidebar-layout/': typeof AuthenticatedSidebarLayoutIndexRoute
  '/_authenticated/_sidebar-layout/estates/me': typeof AuthenticatedSidebarLayoutEstatesMeRoute
  '/_authenticated/_sidebar-layout/estates/': typeof AuthenticatedSidebarLayoutEstatesIndexRoute
  '/_authenticated/_sidebar-layout/projects/': typeof AuthenticatedSidebarLayoutProjectsIndexRoute
  '/shared/flatfinder/$publicId/': typeof SharedFlatfinderPublicIdIndexRoute
  '/shared/folder/$folderId/': typeof SharedFolderFolderIdIndexRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteWithChildren
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteWithChildren
  '/_authenticated/_sidebar-layout/tenant/$tenantId/customer-identity': typeof AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute
  '/_authenticated/_sidebar-layout/tenant/$tenantId/entity-access': typeof AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute
  '/_authenticated/_sidebar-layout/tenant/$tenantId/estates': typeof AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute
  '/_authenticated/_sidebar-layout/tenant/$tenantId/subtenants': typeof AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute
  '/_authenticated/_sidebar-layout/tenant/$tenantId/users': typeof AuthenticatedSidebarLayoutTenantTenantIdUsersRoute
  '/_authenticated/_sidebar-layout/tenant/$tenantId/': typeof AuthenticatedSidebarLayoutTenantTenantIdIndexRoute
  '/shared/virtualTour/$estateId/$tourId/': typeof SharedVirtualTourEstateIdTourIdIndexRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteWithChildren
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteWithChildren
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteWithChildren
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/flatfinder': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteWithChildren
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/floor-plans': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/focus-points': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/images': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/spherical-images': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/videos': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/floor-plans': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/images': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/videos': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/': typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/folder/$folderId': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/folder/$folderId': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/': typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/': typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/logout'
    | '/complete-profile'
    | '/cm416ujis000008jzbr1q4f86'
    | '/login'
    | '/password-reset'
    | '/token-error'
    | '/about'
    | '/contact'
    | '/flatfinders'
    | '/image-rendering'
    | '/image-to-video'
    | '/users'
    | '/profile'
    | '/shadowmap'
    | '/estates/me'
    | '/estates/'
    | '/projects/'
    | '/shared/flatfinder/$publicId/'
    | '/shared/folder/$folderId/'
    | '/estates/$estateId'
    | '/projects/$projectId'
    | '/tenant/$tenantId/customer-identity'
    | '/tenant/$tenantId/entity-access'
    | '/tenant/$tenantId/estates'
    | '/tenant/$tenantId/subtenants'
    | '/tenant/$tenantId/users'
    | '/tenant/$tenantId/'
    | '/shared/virtualTour/$estateId/$tourId/'
    | '/estates/$estateId/analytics'
    | '/estates/$estateId/documents'
    | '/estates/$estateId/media'
    | '/projects/$projectId/documents'
    | '/projects/$projectId/flatfinder'
    | '/projects/$projectId/media'
    | '/projects/$projectId/objects'
    | '/estates/$estateId/'
    | '/projects/$projectId/'
    | '/estates/$estateId/media/virtual-tour/new'
    | '/estates/$estateId/media/digital-twins'
    | '/estates/$estateId/media/floor-plans'
    | '/estates/$estateId/media/focus-points'
    | '/estates/$estateId/media/images'
    | '/estates/$estateId/media/spherical-images'
    | '/estates/$estateId/media/videos'
    | '/projects/$projectId/media/floor-plans'
    | '/projects/$projectId/media/images'
    | '/projects/$projectId/media/videos'
    | '/estates/$estateId/media/'
    | '/projects/$projectId/media/'
    | '/estates/$estateId/documents/'
    | '/projects/$projectId/documents/'
    | '/estates/$estateId/media/virtual-tour/$tourId/view'
    | '/estates/$estateId/media/virtual-tour/$tourId/'
    | '/estates/$estateId/documents/$archiveId/'
    | '/projects/$projectId/documents/$archiveId/'
    | '/estates/$estateId/documents/$archiveId/folder/$folderId'
    | '/projects/$projectId/documents/$archiveId/folder/$folderId'
    | '/estates/$estateId/media/edit/$mediaId/'
    | '/projects/$projectId/media/edit/$mediaId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/logout'
    | '/complete-profile'
    | '/cm416ujis000008jzbr1q4f86'
    | '/login'
    | '/password-reset'
    | '/token-error'
    | '/about'
    | '/contact'
    | '/flatfinders'
    | '/image-rendering'
    | '/image-to-video'
    | '/users'
    | '/profile'
    | '/shadowmap'
    | '/estates/me'
    | '/estates'
    | '/projects'
    | '/shared/flatfinder/$publicId'
    | '/shared/folder/$folderId'
    | '/tenant/$tenantId/customer-identity'
    | '/tenant/$tenantId/entity-access'
    | '/tenant/$tenantId/estates'
    | '/tenant/$tenantId/subtenants'
    | '/tenant/$tenantId/users'
    | '/tenant/$tenantId'
    | '/shared/virtualTour/$estateId/$tourId'
    | '/estates/$estateId/analytics'
    | '/projects/$projectId/flatfinder'
    | '/projects/$projectId/objects'
    | '/estates/$estateId'
    | '/projects/$projectId'
    | '/estates/$estateId/media/virtual-tour/new'
    | '/estates/$estateId/media/digital-twins'
    | '/estates/$estateId/media/floor-plans'
    | '/estates/$estateId/media/focus-points'
    | '/estates/$estateId/media/images'
    | '/estates/$estateId/media/spherical-images'
    | '/estates/$estateId/media/videos'
    | '/projects/$projectId/media/floor-plans'
    | '/projects/$projectId/media/images'
    | '/projects/$projectId/media/videos'
    | '/estates/$estateId/media'
    | '/projects/$projectId/media'
    | '/estates/$estateId/documents'
    | '/projects/$projectId/documents'
    | '/estates/$estateId/media/virtual-tour/$tourId/view'
    | '/estates/$estateId/media/virtual-tour/$tourId'
    | '/estates/$estateId/documents/$archiveId'
    | '/projects/$projectId/documents/$archiveId'
    | '/estates/$estateId/documents/$archiveId/folder/$folderId'
    | '/projects/$projectId/documents/$archiveId/folder/$folderId'
    | '/estates/$estateId/media/edit/$mediaId'
    | '/projects/$projectId/media/edit/$mediaId'
  id:
    | '__root__'
    | '/_auth-layout'
    | '/_authenticated'
    | '/logout'
    | '/complete-profile'
    | '/_auth-layout/cm416ujis000008jzbr1q4f86'
    | '/_authenticated/_nosidebar-layout'
    | '/_authenticated/_sidebar-layout'
    | '/_auth-layout/login'
    | '/_auth-layout/password-reset'
    | '/_auth-layout/token-error'
    | '/_authenticated/_sidebar-layout/about'
    | '/_authenticated/_sidebar-layout/contact'
    | '/_authenticated/_sidebar-layout/flatfinders'
    | '/_authenticated/_sidebar-layout/image-rendering'
    | '/_authenticated/_sidebar-layout/image-to-video'
    | '/_authenticated/_sidebar-layout/users'
    | '/_authenticated/_sidebar-layout/profile'
    | '/_authenticated/_sidebar-layout/shadowmap'
    | '/_authenticated/_sidebar-layout/'
    | '/_authenticated/_sidebar-layout/estates/me'
    | '/_authenticated/_sidebar-layout/estates/'
    | '/_authenticated/_sidebar-layout/projects/'
    | '/shared/flatfinder/$publicId/'
    | '/shared/folder/$folderId/'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout'
    | '/_authenticated/_sidebar-layout/tenant/$tenantId/customer-identity'
    | '/_authenticated/_sidebar-layout/tenant/$tenantId/entity-access'
    | '/_authenticated/_sidebar-layout/tenant/$tenantId/estates'
    | '/_authenticated/_sidebar-layout/tenant/$tenantId/subtenants'
    | '/_authenticated/_sidebar-layout/tenant/$tenantId/users'
    | '/_authenticated/_sidebar-layout/tenant/$tenantId/'
    | '/shared/virtualTour/$estateId/$tourId/'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/flatfinder'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/'
    | '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/floor-plans'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/focus-points'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/images'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/spherical-images'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/videos'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/floor-plans'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/images'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/videos'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/'
    | '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view'
    | '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/folder/$folderId'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/folder/$folderId'
    | '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/'
    | '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LogoutRoute: typeof LogoutRoute
  CompleteProfileLazyRoute: typeof CompleteProfileLazyRoute
  SharedFlatfinderPublicIdIndexRoute: typeof SharedFlatfinderPublicIdIndexRoute
  SharedFolderFolderIdIndexRoute: typeof SharedFolderFolderIdIndexRoute
  SharedVirtualTourEstateIdTourIdIndexRoute: typeof SharedVirtualTourEstateIdTourIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-layout': {
      id: '/_auth-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-layout/token-error': {
      id: '/_auth-layout/token-error'
      path: '/token-error'
      fullPath: '/token-error'
      preLoaderRoute: typeof AuthLayoutTokenErrorLazyRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth-layout/password-reset': {
      id: '/_auth-layout/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof AuthLayoutPasswordResetLazyRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth-layout/login': {
      id: '/_auth-layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLayoutLoginLazyRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authenticated/_sidebar-layout': {
      id: '/_authenticated/_sidebar-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_nosidebar-layout': {
      id: '/_authenticated/_nosidebar-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedNosidebarLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth-layout/cm416ujis000008jzbr1q4f86': {
      id: '/_auth-layout/cm416ujis000008jzbr1q4f86'
      path: '/cm416ujis000008jzbr1q4f86'
      fullPath: '/cm416ujis000008jzbr1q4f86'
      preLoaderRoute: typeof AuthLayoutCm416ujis000008jzbr1q4f86RouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authenticated/_sidebar-layout/': {
      id: '/_authenticated/_sidebar-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/shadowmap': {
      id: '/_authenticated/_sidebar-layout/shadowmap'
      path: '/shadowmap'
      fullPath: '/shadowmap'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutShadowmapLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/profile': {
      id: '/_authenticated/_sidebar-layout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProfileLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/users': {
      id: '/_authenticated/_sidebar-layout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutUsersRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/image-to-video': {
      id: '/_authenticated/_sidebar-layout/image-to-video'
      path: '/image-to-video'
      fullPath: '/image-to-video'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutImageToVideoRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/image-rendering': {
      id: '/_authenticated/_sidebar-layout/image-rendering'
      path: '/image-rendering'
      fullPath: '/image-rendering'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutImageRenderingRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/flatfinders': {
      id: '/_authenticated/_sidebar-layout/flatfinders'
      path: '/flatfinders'
      fullPath: '/flatfinders'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutFlatfindersRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/contact': {
      id: '/_authenticated/_sidebar-layout/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutContactRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/about': {
      id: '/_authenticated/_sidebar-layout/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutAboutRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/shared/folder/$folderId/': {
      id: '/shared/folder/$folderId/'
      path: '/shared/folder/$folderId'
      fullPath: '/shared/folder/$folderId/'
      preLoaderRoute: typeof SharedFolderFolderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared/flatfinder/$publicId/': {
      id: '/shared/flatfinder/$publicId/'
      path: '/shared/flatfinder/$publicId'
      fullPath: '/shared/flatfinder/$publicId/'
      preLoaderRoute: typeof SharedFlatfinderPublicIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_sidebar-layout/projects/': {
      id: '/_authenticated/_sidebar-layout/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/estates/': {
      id: '/_authenticated/_sidebar-layout/estates/'
      path: '/estates'
      fullPath: '/estates/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/estates/me': {
      id: '/_authenticated/_sidebar-layout/estates/me'
      path: '/estates/me'
      fullPath: '/estates/me'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesMeRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/shared/virtualTour/$estateId/$tourId/': {
      id: '/shared/virtualTour/$estateId/$tourId/'
      path: '/shared/virtualTour/$estateId/$tourId'
      fullPath: '/shared/virtualTour/$estateId/$tourId/'
      preLoaderRoute: typeof SharedVirtualTourEstateIdTourIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_sidebar-layout/tenant/$tenantId/': {
      id: '/_authenticated/_sidebar-layout/tenant/$tenantId/'
      path: '/tenant/$tenantId'
      fullPath: '/tenant/$tenantId/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/tenant/$tenantId/users': {
      id: '/_authenticated/_sidebar-layout/tenant/$tenantId/users'
      path: '/tenant/$tenantId/users'
      fullPath: '/tenant/$tenantId/users'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdUsersRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/tenant/$tenantId/subtenants': {
      id: '/_authenticated/_sidebar-layout/tenant/$tenantId/subtenants'
      path: '/tenant/$tenantId/subtenants'
      fullPath: '/tenant/$tenantId/subtenants'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/tenant/$tenantId/estates': {
      id: '/_authenticated/_sidebar-layout/tenant/$tenantId/estates'
      path: '/tenant/$tenantId/estates'
      fullPath: '/tenant/$tenantId/estates'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdEstatesRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/tenant/$tenantId/entity-access': {
      id: '/_authenticated/_sidebar-layout/tenant/$tenantId/entity-access'
      path: '/tenant/$tenantId/entity-access'
      fullPath: '/tenant/$tenantId/entity-access'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/tenant/$tenantId/customer-identity': {
      id: '/_authenticated/_sidebar-layout/tenant/$tenantId/customer-identity'
      path: '/tenant/$tenantId/customer-identity'
      fullPath: '/tenant/$tenantId/customer-identity'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout'
      path: '/estates/$estateId'
      fullPath: '/estates/$estateId'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/'
      path: '/'
      fullPath: '/estates/$estateId/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/objects'
      path: '/objects'
      fullPath: '/projects/$projectId/objects'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media'
      path: '/media'
      fullPath: '/projects/$projectId/media'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/flatfinder': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/flatfinder'
      path: '/flatfinder'
      fullPath: '/projects/$projectId/flatfinder'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents'
      path: '/documents'
      fullPath: '/projects/$projectId/documents'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media'
      path: '/media'
      fullPath: '/estates/$estateId/media'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents'
      path: '/documents'
      fullPath: '/estates/$estateId/documents'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics'
      path: '/analytics'
      fullPath: '/estates/$estateId/analytics'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/'
      path: '/'
      fullPath: '/projects/$projectId/documents/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/'
      path: '/'
      fullPath: '/estates/$estateId/documents/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/'
      path: '/'
      fullPath: '/projects/$projectId/media/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/'
      path: '/'
      fullPath: '/estates/$estateId/media/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/videos': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/videos'
      path: '/videos'
      fullPath: '/projects/$projectId/media/videos'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/images': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/images'
      path: '/images'
      fullPath: '/projects/$projectId/media/images'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/floor-plans': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/floor-plans'
      path: '/floor-plans'
      fullPath: '/projects/$projectId/media/floor-plans'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/videos': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/videos'
      path: '/videos'
      fullPath: '/estates/$estateId/media/videos'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/spherical-images': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/spherical-images'
      path: '/spherical-images'
      fullPath: '/estates/$estateId/media/spherical-images'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/images': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/images'
      path: '/images'
      fullPath: '/estates/$estateId/media/images'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/focus-points': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/focus-points'
      path: '/focus-points'
      fullPath: '/estates/$estateId/media/focus-points'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/floor-plans': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/floor-plans'
      path: '/floor-plans'
      fullPath: '/estates/$estateId/media/floor-plans'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins'
      path: '/digital-twins'
      fullPath: '/estates/$estateId/media/digital-twins'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new': {
      id: '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new'
      path: '/estates/$estateId/media/virtual-tour/new'
      fullPath: '/estates/$estateId/media/virtual-tour/new'
      preLoaderRoute: typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRouteImport
      parentRoute: typeof AuthenticatedNosidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/'
      path: '/$archiveId'
      fullPath: '/projects/$projectId/documents/$archiveId/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/'
      path: '/$archiveId'
      fullPath: '/estates/$estateId/documents/$archiveId/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute
    }
    '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/': {
      id: '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/'
      path: '/estates/$estateId/media/virtual-tour/$tourId'
      fullPath: '/estates/$estateId/media/virtual-tour/$tourId/'
      preLoaderRoute: typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRouteImport
      parentRoute: typeof AuthenticatedNosidebarLayoutRoute
    }
    '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view': {
      id: '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view'
      path: '/estates/$estateId/media/virtual-tour/$tourId/view'
      fullPath: '/estates/$estateId/media/virtual-tour/$tourId/view'
      preLoaderRoute: typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRouteImport
      parentRoute: typeof AuthenticatedNosidebarLayoutRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/'
      path: '/edit/$mediaId'
      fullPath: '/projects/$projectId/media/edit/$mediaId/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/'
      path: '/edit/$mediaId'
      fullPath: '/estates/$estateId/media/edit/$mediaId/'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute
    }
    '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/folder/$folderId': {
      id: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents/$archiveId/folder/$folderId'
      path: '/$archiveId/folder/$folderId'
      fullPath: '/projects/$projectId/documents/$archiveId/folder/$folderId'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute
    }
    '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/folder/$folderId': {
      id: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents/$archiveId/folder/$folderId'
      path: '/$archiveId/folder/$folderId'
      fullPath: '/estates/$estateId/documents/$archiveId/folder/$folderId'
      preLoaderRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRouteImport
      parentRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute
    }
  }
}

interface AuthLayoutRouteChildren {
  AuthLayoutCm416ujis000008jzbr1q4f86Route: typeof AuthLayoutCm416ujis000008jzbr1q4f86Route
  AuthLayoutLoginLazyRoute: typeof AuthLayoutLoginLazyRoute
  AuthLayoutPasswordResetLazyRoute: typeof AuthLayoutPasswordResetLazyRoute
  AuthLayoutTokenErrorLazyRoute: typeof AuthLayoutTokenErrorLazyRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutCm416ujis000008jzbr1q4f86Route:
    AuthLayoutCm416ujis000008jzbr1q4f86Route,
  AuthLayoutLoginLazyRoute: AuthLayoutLoginLazyRoute,
  AuthLayoutPasswordResetLazyRoute: AuthLayoutPasswordResetLazyRoute,
  AuthLayoutTokenErrorLazyRoute: AuthLayoutTokenErrorLazyRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface AuthenticatedNosidebarLayoutRouteChildren {
  AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute: typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute
  AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute: typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute
  AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute: typeof AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute
}

const AuthenticatedNosidebarLayoutRouteChildren: AuthenticatedNosidebarLayoutRouteChildren =
  {
    AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute:
      AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourNewRoute,
    AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute:
      AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdViewRoute,
    AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute:
      AuthenticatedNosidebarLayoutEstatesEstateIdMediaVirtualTourTourIdIndexRoute,
  }

const AuthenticatedNosidebarLayoutRouteWithChildren =
  AuthenticatedNosidebarLayoutRoute._addFileChildren(
    AuthenticatedNosidebarLayoutRouteChildren,
  )

interface AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteChildren {
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
}

const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteChildren: AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteChildren =
  {
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsIndexLazyRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute,
  }

const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteWithChildren =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute._addFileChildren(
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteChildren,
  )

interface AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteChildren {
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute
}

const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteChildren: AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteChildren =
  {
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaDigitalTwinsRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFloorPlansRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaFocusPointsRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaImagesRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaSphericalImagesRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaVideosRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaIndexRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaEditMediaIdIndexRoute,
  }

const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteWithChildren =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute._addFileChildren(
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteChildren,
  )

interface AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteChildren {
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteWithChildren
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteWithChildren
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute
}

const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteChildren: AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteChildren =
  {
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutAnalyticsRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutDocumentsRouteWithChildren,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutMediaRouteWithChildren,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutIndexRoute,
  }

const AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteWithChildren =
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute._addFileChildren(
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteChildren,
  )

interface AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteChildren {
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute
}

const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteChildren: AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteChildren =
  {
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsIndexLazyRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdIndexLazyRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsArchiveIdFolderFolderIdLazyRoute,
  }

const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteWithChildren =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute._addFileChildren(
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteChildren,
  )

interface AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteChildren {
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute
}

const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteChildren: AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteChildren =
  {
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaFloorPlansRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaImagesRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaVideosRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaIndexRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaEditMediaIdIndexRoute,
  }

const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteWithChildren =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute._addFileChildren(
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteChildren,
  )

interface AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteChildren {
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteWithChildren
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteWithChildren
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute
}

const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteChildren: AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteChildren =
  {
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutDocumentsRouteWithChildren,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutFlatfinderRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutMediaRouteWithChildren,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutObjectsRoute,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutIndexRoute,
  }

const AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteWithChildren =
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute._addFileChildren(
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteChildren,
  )

interface AuthenticatedSidebarLayoutRouteChildren {
  AuthenticatedSidebarLayoutAboutRoute: typeof AuthenticatedSidebarLayoutAboutRoute
  AuthenticatedSidebarLayoutContactRoute: typeof AuthenticatedSidebarLayoutContactRoute
  AuthenticatedSidebarLayoutFlatfindersRoute: typeof AuthenticatedSidebarLayoutFlatfindersRoute
  AuthenticatedSidebarLayoutImageRenderingRoute: typeof AuthenticatedSidebarLayoutImageRenderingRoute
  AuthenticatedSidebarLayoutImageToVideoRoute: typeof AuthenticatedSidebarLayoutImageToVideoRoute
  AuthenticatedSidebarLayoutUsersRoute: typeof AuthenticatedSidebarLayoutUsersRoute
  AuthenticatedSidebarLayoutProfileLazyRoute: typeof AuthenticatedSidebarLayoutProfileLazyRoute
  AuthenticatedSidebarLayoutShadowmapLazyRoute: typeof AuthenticatedSidebarLayoutShadowmapLazyRoute
  AuthenticatedSidebarLayoutIndexRoute: typeof AuthenticatedSidebarLayoutIndexRoute
  AuthenticatedSidebarLayoutEstatesMeRoute: typeof AuthenticatedSidebarLayoutEstatesMeRoute
  AuthenticatedSidebarLayoutEstatesIndexRoute: typeof AuthenticatedSidebarLayoutEstatesIndexRoute
  AuthenticatedSidebarLayoutProjectsIndexRoute: typeof AuthenticatedSidebarLayoutProjectsIndexRoute
  AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute: typeof AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteWithChildren
  AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute: typeof AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteWithChildren
  AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute
  AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute
  AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute
  AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute
  AuthenticatedSidebarLayoutTenantTenantIdUsersRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdUsersRoute
  AuthenticatedSidebarLayoutTenantTenantIdIndexRoute: typeof AuthenticatedSidebarLayoutTenantTenantIdIndexRoute
}

const AuthenticatedSidebarLayoutRouteChildren: AuthenticatedSidebarLayoutRouteChildren =
  {
    AuthenticatedSidebarLayoutAboutRoute: AuthenticatedSidebarLayoutAboutRoute,
    AuthenticatedSidebarLayoutContactRoute:
      AuthenticatedSidebarLayoutContactRoute,
    AuthenticatedSidebarLayoutFlatfindersRoute:
      AuthenticatedSidebarLayoutFlatfindersRoute,
    AuthenticatedSidebarLayoutImageRenderingRoute:
      AuthenticatedSidebarLayoutImageRenderingRoute,
    AuthenticatedSidebarLayoutImageToVideoRoute:
      AuthenticatedSidebarLayoutImageToVideoRoute,
    AuthenticatedSidebarLayoutUsersRoute: AuthenticatedSidebarLayoutUsersRoute,
    AuthenticatedSidebarLayoutProfileLazyRoute:
      AuthenticatedSidebarLayoutProfileLazyRoute,
    AuthenticatedSidebarLayoutShadowmapLazyRoute:
      AuthenticatedSidebarLayoutShadowmapLazyRoute,
    AuthenticatedSidebarLayoutIndexRoute: AuthenticatedSidebarLayoutIndexRoute,
    AuthenticatedSidebarLayoutEstatesMeRoute:
      AuthenticatedSidebarLayoutEstatesMeRoute,
    AuthenticatedSidebarLayoutEstatesIndexRoute:
      AuthenticatedSidebarLayoutEstatesIndexRoute,
    AuthenticatedSidebarLayoutProjectsIndexRoute:
      AuthenticatedSidebarLayoutProjectsIndexRoute,
    AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRoute:
      AuthenticatedSidebarLayoutEstatesEstateIdDashboardLayoutRouteWithChildren,
    AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRoute:
      AuthenticatedSidebarLayoutProjectsProjectIdDashboardLayoutRouteWithChildren,
    AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute:
      AuthenticatedSidebarLayoutTenantTenantIdCustomerIdentityRoute,
    AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute:
      AuthenticatedSidebarLayoutTenantTenantIdEntityAccessRoute,
    AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute:
      AuthenticatedSidebarLayoutTenantTenantIdEstatesRoute,
    AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute:
      AuthenticatedSidebarLayoutTenantTenantIdSubtenantsRoute,
    AuthenticatedSidebarLayoutTenantTenantIdUsersRoute:
      AuthenticatedSidebarLayoutTenantTenantIdUsersRoute,
    AuthenticatedSidebarLayoutTenantTenantIdIndexRoute:
      AuthenticatedSidebarLayoutTenantTenantIdIndexRoute,
  }

const AuthenticatedSidebarLayoutRouteWithChildren =
  AuthenticatedSidebarLayoutRoute._addFileChildren(
    AuthenticatedSidebarLayoutRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedNosidebarLayoutRoute: typeof AuthenticatedNosidebarLayoutRouteWithChildren
  AuthenticatedSidebarLayoutRoute: typeof AuthenticatedSidebarLayoutRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedNosidebarLayoutRoute:
    AuthenticatedNosidebarLayoutRouteWithChildren,
  AuthenticatedSidebarLayoutRoute: AuthenticatedSidebarLayoutRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LogoutRoute: LogoutRoute,
  CompleteProfileLazyRoute: CompleteProfileLazyRoute,
  SharedFlatfinderPublicIdIndexRoute: SharedFlatfinderPublicIdIndexRoute,
  SharedFolderFolderIdIndexRoute: SharedFolderFolderIdIndexRoute,
  SharedVirtualTourEstateIdTourIdIndexRoute:
    SharedVirtualTourEstateIdTourIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
